import { Component, OnInit, SimpleChange, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormMode, Carrier } from 'src/app/_models/models';
import { FormBuilder, FormControl, FormGroup, FormArray, NgForm } from '@angular/forms';
import { AlertService, AlertOptions, AlertTypes, AlertMessage, AlertSeverity } from 'src/app/alert/alert.component';
import { CarriersService } from 'src/app/services/api/carriers.service';
import { CommonService } from 'src/app/services/common.service';
import { RouterOutlet } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { SnackbarComponent } from 'src/app/Shared Components/snackbar/snackbar.component';
import { MessagePopupComponent } from 'src/app/Shared Components/message-popup/message-popup.component';
import { SelectItem } from 'primeng/api';
// import { providerDef } from '@angular/core/src/view';
import { take, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-administration-carrier-index-component',
  templateUrl: './carrier.component.html',
  styleUrls: ['./carrier.component.scss'],
  encapsulation : ViewEncapsulation.None

})

// https://stackoverflow.com/questions/55617772/angular-7-multiple-outlets-error-cannot-activate-an-already-activated-outle
export class AdministrationCarrierIndexComponent implements OnInit {

  @ViewChild(RouterOutlet) outlet: RouterOutlet;
  @ViewChild('showratedFilesPopup') showratedFilesPopup: TemplateRef<any>;
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  //@ViewChild(MatPaginator) showratepaginator: MatPaginator;
  @ViewChild('dataSourcepaginator') dataSourcepaginator: MatPaginator;
  //@ViewChild('ShowRateFileDataSourcepaginator') ShowRateFileDataSourcepaginator: MatPaginator;

  //CarriersCols: string[] = ['Name','engine', 'BillingID', 'BillingContactID', 'BillingDay','BillingFrequency','LastBilled','CarrierId','...'];
  // CarriersCols: string[] = ['Name', 'engine','accountNumber','TrackingPrefix','TrackingSuffix','MaxTracking','CurrentTracking','TrackingFormat','AutoSetTrackingNumber','...'];
  CarriersCols: string[] = ['Name', 'engine','accountNumber','TrackingPrefix','TrackingSuffix','TrackingFormat','AutoSetTrackingNumber','...'];

  public Carriers: Carrier[];
  public Carrier: Carrier;

  public Mode: FormMode = FormMode.None;
  public FileManagerMode: FormMode = FormMode.None;
  public FormModes = FormMode;

  tabledata : any;
  public cols: any[];

  // @ViewChild('dt') formRateFileDataTable: any;
  // @ViewChild('dt2') carrierRateTTable: any;

  engines: SelectItem[] = [
    { label: "FX", value: "FX" },
    { label: "GLS", value: "GLS" },
    { label: "UPS", value: "UPS" },
    { label: "Better Trucks", value: "BetterTrucks" },
    { label: "TLS Parcel", value: "TLS" },
    { label: "LSO", value: "LSO" },
    { label: "EasyPost", value: "EP" },
    { label: "GORI", value: "GORI" }
  ];

  public showdiag: boolean = false;
  public diagmsg: string;
  pageNumber: number = 0;
  pageSize: number = 10;
  pageLength: number;

  public CarriersDtCols = [
    // { field: 'id', header: 'Id' },
    { field: 'name', header: 'Name' },
    { field: 'engine', header: 'Engine' },
    { field: 'accountNumber', header: 'AccountNumber' }
  ];

  MatRateFileDtCols: string[] = ['name','label', 'fileOriginalName', 'fileVersion', 'uploadedOn','status','...'];

  CarrierControllerUrl: string;
  ProviderControllerUrl: string;

  constructor(private carriers: CarriersService, private alert: AlertService, private comm:CommonService,
    public dialog: MatDialog, private _snackBar: MatSnackBar, private fb: FormBuilder) {
    //this.FileLabel = 'Sample5';
    this.Carrier = new Carrier();
    this.CarrierControllerUrl = comm.getApiAddress() + '/Carriers';
    this.CarrierControllerUrl = comm.getApiAddress() + '/Providers';

    this.alert.Receiver.subscribe((receiver) => {
      //alert(receiver.Response);
    });

    this.loadCarriers(this.pageNumber, this.pageSize);
  }

  childAccountsForm: FormGroup;
  childAccountSubscriptions: Subscription[] = [];

  ngOnInit() {
    this.loadCarriers(this.pageNumber, this.pageSize);

    this.childAccountsForm = this.fb.group({
      childAccounts: this.fb.array([])
    });
    this.cols = [
      { field: 'id', header: 'Id' },
      { field: 'name', header: 'Name' },
      { field: 'engine', header: 'Engine' },
      { field: 'accountNumber', header: 'AccountNumber' }
  ];
  }
  ngOnChanges() {


  }
  ngAfterViewInit(){
    if (this.dataSource != undefined) {
      this.dataSource.paginator = this.dataSourcepaginator;
      this.dataSource.sort = this.sort;
    }
    // this.ShowRateFileDataSource.paginator = this.showratepaginator;
    // this.ShowRateFileDataSource.sort = this.sort
  }

  onChangedPageSize($event){
    console.log($event);
  }
  carrierName: string;

  get childAccounts(): FormArray {
    return this.childAccountsForm.get('childAccounts') as FormArray;
  }

public onSubmitForm(form : any){
    this.dialog
    .open(MessagePopupComponent, {
      data: {
        title: 'Delete Carrier',
        confirmText: 'Delete',
        cancelText: 'Cancel',
        message: 'Are you sure you want to DELETE selected Carrier?',
        // alertcontent: '*you cannot undo the changes',
      },
    })
    .afterClosed()
    .subscribe((res) => {
      if(res)
    this.onSubmit(form);
    });
}
  public onSubmit(form: any) {
    switch (this.Mode) {
      case FormMode.Find: {
        this.carriers.getAllCarriers(this.carrierName, this.pageNumber + 1, this.pageSize).subscribe(
         ( r: any) => {
           //debugger;
            this.Carriers = r.data;
            this.tabledata = r.data;
            this.dataSource = new MatTableDataSource(  this.tabledata );
            this.dataSource.paginator = this.dataSourcepaginator;
            this.dataSource.sort = this.sort;
            this.pageLength = r.totalRecords;
          },
          e => {
            // this.alert.send(AlertMessage.getOnHttpError("GetCarriersFail", "Failed to get carriers", e));
            this.openSnackBar('Failed to get carriers', 'error');

          }
        );
        break;
      }
      case FormMode.New: {
        if (form.invalid) {

        } else {
          if (form.value.Engine == "FX" || form.value.Engine == "UPS" || form.value.Engine == "GLS" || form.value.Engine == "BetterTrucks" || form.value.Engine == "LSO" || form.value.Engine == "EP" || form.value.Engine == "GORI") {
            this.post(form);
          } else {
            this.alert.send(new AlertMessage("Carrier Engine should be FX, UPS, GLS, BetterTrucks, GORI", "Carrier Engine should be FX, UPS, GLS, BetterTrucks, GORI", AlertSeverity.Error));
          }
        }
        break;
      }
      case FormMode.Edit: {
        if (form.invalid) {

        } else {
          this.put(form);
        }
        break;
      }
      case FormMode.Del: {
        this.delete();
        break;
      }
      default: {
        break;
      }
    }
  }

  public post(form: any) {
    this.carriers.create(this.Carrier).subscribe(
      r => {
        form.resetForm();
        this.resetForm();
        this.loadCarriers(this.pageNumber, this.pageSize);
        if ( r == null) {
          this.openSnackBar('Carrier already exists with the same name', 'success');
        } else {
          this.openSnackBar('Saved sucessfully', 'success');
        }

      },
      e => {
        this.openSnackBar('Failed to save', 'error');
      }
    );
  }

  public put(form: any) {
   //debugger;
    if(this.Carrier.trackingFormat.toString() == "")
    {
      this.Carrier.trackingFormat = 0;
    }
    this.carriers.update(this.Carrier).subscribe(
      r => {
        form.resetForm();
        this.resetForm();
        this.loadCarriers(this.pageNumber, this.pageSize);
        this.openSnackBar('Updated sucessfully', 'success');

      },
      e => {
        this.openSnackBar('Failed to update', 'error');

      }
    );
  }

  public delete() {
    this.carriers.delete(this.Carrier.id).subscribe(
      r => {
        this.resetForm();
        this.loadCarriers(this.pageNumber, this.pageSize);
        this.openSnackBar('Deleted sucessfully', 'success');

      },
      e => {
        this.openSnackBar('Failed to delete', 'error');
      }
    );
  }

  public showMessage(msg: string) {
    this.diagmsg = msg;
    this.showdiag = true;
  }

  onPageChange(event: PageEvent) {
    this.pageNumber = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadCarriers(this.pageNumber, this.pageSize);
  }

  public loadCarriers(pageNum, pageSizee) {
    //this.snackservice.loader();
    this.carriers.getAllCarriers(null, pageNum + 1, pageSizee).subscribe(
      (r: any) => {
        this.Carriers = r.data;
        this.tabledata = r.data;
        this.dataSource = new MatTableDataSource(  this.tabledata );
        this.dataSource.paginator = this.dataSourcepaginator;
        this.dataSource.sort = this.sort;
        this.pageLength = r.totalRecords;
        // setTimeout(() => {
        //   this.snackservice.CloseProgressSpinner(true);
        // },300);
      },
      e => {
        // setTimeout(() => {
        //   this.snackservice.CloseProgressSpinner(true);
        //   setTimeout(() => {
        //     //this.snackservice.open(options);
        //     this.openSnackBar('Failed to get carriers', 'error');
        //   },200);
        // },400);
        // this.alert.send(AlertMessage.getOnHttpError("GetCarriersFail", "Failed to get carriers", e));
        this.openSnackBar('Failed to get carriers', 'error');

      }
    );
  }

  public resetForm() {
    this.loadCarriers(this.pageNumber,this.pageSize);
    if (this.Mode == FormMode.Find) {
      this.carrierName = null;
      this.carriers.getAll(this.carrierName).subscribe(
        (r: any) => {
          this.Carriers = r;
        },
        e => {
          // this.alert.send(AlertMessage.getOnHttpError("GetCarriersFail", "Failed to get carriers", e));
          this.openSnackBar('Failed to get carriers', 'error');

        }
      );
    }

    this.Mode = FormMode.None;
    this.Carrier.selected = false;
    this.Carrier = new Carrier();
    if (this.childAccountSubscriptions != null)
      this.childAccountSubscriptions.forEach(x => x.unsubscribe());
  }

  public showFind() {
    this.Mode = FormMode.Find;
    this.Carrier.selected = false;
    this.Carrier = new Carrier();
    if (this.childAccountSubscriptions != null)
      this.childAccountSubscriptions.forEach(x => x.unsubscribe());
  }

  public showNew() {
    this.Mode = FormMode.New;
    this.Carrier.selected = false;
    this.Carrier = new Carrier();
  }

  public showEdit(p: Carrier) {
    this.Mode = FormMode.Edit;
    this.Carrier.selected = false;
    this.Carrier = p;
    this.Carrier.selected = true;

    this.setChildAccounts(p);

  }

  public showDel(p: Carrier) {
    this.Mode = FormMode.Del;
    this.Carrier.selected = false;
    this.Carrier = p;
    this.Carrier.selected = true;
  }

  close(){
    this.dialog.closeAll();
    this.dataSource = new MatTableDataSource( this.tabledata );
    this.dataSource.paginator = this.dataSourcepaginator;
  }






  //ChildAccounts
  private setChildAccounts(p) {
    for (let clientCarrier of p.childAccounts) {

    }

    const childAccountFGs = p.childAccounts.map(element => this.fb.group(element));
    const childAccountFormArray = this.fb.array(childAccountFGs);
    this.childAccountsForm.setControl('childAccounts', childAccountFormArray);

    this.subscribeChildAccounts();
  }
  addChildAccount() {
    let newRow = {
      carrier: new FormControl (null),
      carrierId: new FormControl (0),
      name: new FormControl (""),
      accountNumber: new FormControl (""),
      active: new FormControl (true),
      id: new FormControl (0),
        selected: new FormControl(true)
    };
    this.childAccounts.push(this.fb.group(newRow));
    this.subscribeChildAccount(this.childAccounts.controls[this.childAccounts.length - 1] as FormControl, this.childAccounts.length - 1);
  }
  saveChildAccount(element, index) {

    var Id = localStorage.getItem('Id');
    let req = {
      Carrier: null,
      CarrierId: this.Carrier.id,
      Name: element.name,
      AccountNumber: element.accountNumber,
      Active: true,
      Id: element.id,
    }

    //this.ClientdataSource.paginator = this.paginator;
    this.carriers.saveChildAccount(req).subscribe(
      r => {
        this.openSnackBar('Saved sucessfully', 'success');
        if (element.id == 0) {
          element.id = r.id;
          (this.childAccounts.controls[index] as FormGroup).controls.id.setValue(r.id);
        }
      },
      e => {
        this.openSnackBar('Failed to save child account', 'error');
      });

  }
  removeChildAccount(index) {
    var data = this.childAccounts.controls[index].value;

    if (data.id > 0) {

      this.dialog
        .open(MessagePopupComponent, {
          data: {
            title: 'Delete child account',
            confirmText: 'Remove',
            cancelText: 'No',
            message: 'Are you sure you want to remove this child account from the selected carrier?',
          },
        })
        .afterClosed()
        .subscribe((res) => {
          if (res) {
            //const childAccountChildAccountIdValue = event.childAccountChildAccount?.id ?? 0;
            this.carriers.deleteChildAccount(data.id).subscribe(result => {
              this.openSnackBar('Child account removed successfully', 'success');
              this.childAccounts.removeAt(index);
            }, error => {
              this.openSnackBar('Failed to remove child account', 'error');
            });
          }
        });
    }
    else {
      this.childAccounts.removeAt(index);
    }

  }
  subscribeChildAccounts(): void {
    this.childAccounts.controls.forEach((control, index) => {
      this.subscribeChildAccount(control as FormControl, index);
    });
  }
  subscribeChildAccount(control: FormControl, index: number): void {
    const sub = control.valueChanges
      .pipe(
        debounceTime(1500), // avoid firing on every keystroke
        distinctUntilChanged()
      )
      .subscribe(value => {
        this.saveChildAccount(value, index);
      });

    this.childAccountSubscriptions.push(sub);
  }

  openSnackBar(message: string, messageType:'error'|'success'|'notification') {
    let config = new MatSnackBarConfig();
    config.data = {
      message: message,
      type:messageType
    };
    config.duration = environment.messageTimeOut;
    config.verticalPosition = 'top';
    config.horizontalPosition = 'center';
    config.panelClass =messageType;
    this._snackBar.openFromComponent(SnackbarComponent, config);
  }
}
